import React from 'react';
import * as _ from 'lodash';
import { Link } from 'react-router-dom';

import config from '../../config';
import paths from '../../constants/routes.json';
import { Listings_ListingData_listings } from '../../types/graph/Listings_ListingData';
import { AcademicCapIcon } from '@heroicons/react/solid';
import { EyeIcon } from '@heroicons/react/outline';

interface IProps {
  listing: Listings_ListingData_listings | null;
}

const ListingCard: React.FC<IProps> = ({ listing }) => {
  if (!listing) return null;

  return (
    <li className="relative col-span-1 flex flex-col text-center bg-white overflow-hidden rounded-lg shadow divide-y divide-gray-200">
      <div className="flex-1 flex flex-col">
        {_.get(
          listing?.property?.media?.filter((i) => !!i && i.type === 'image'),
          '[0].filePath',
          false
        ) ? (
          <img
            className="w-full h-32 object-cover"
            src={_.get(
              listing?.property?.media?.filter(
                (i) => !!i && i.type === 'image'
              ),
              '[0].filePath',
              ''
            )}
            alt="tmp"
          />
        ) : (
          <svg
            className="w-full bg-gray-50 h-32 flex-shrink-0 mx-auto text-gray-300"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 12H4l4-8 3 6 2-4 3 6z"
              clipRule="evenodd"
            />
          </svg>
        )}
        <p className="mt-3 mb-4 text-base font-bold text-gray-900 sm:text-lg">
          {_.get(listing, 'property.address.street', '')}
          <p className="text-gray-400 text-xs font-normal">
            {`${_.get(listing, 'property.address.city', '')}, ${_.get(
              listing,
              'property.address.region',
              ''
            )}, ${_.get(listing, 'property.address.country', '')}`}
          </p>
        </p>
        <dl className="absolute top-0 right-2">
          <dd className="mt-3">
            <span
              className={`${
                _.get(listing, 'status', null) === 'active'
                  ? 'text-green-800 bg-green-100'
                  : 'text-gray-800 bg-gray-200'
              } px-2 py-1 text-xs font-medium rounded-full`}
            >
              {(_.get(listing, 'status', 'disabled') || 'disabled')
                .charAt(0)
                .toUpperCase() +
                (_.get(listing, 'status', 'disabled') || 'disabled')
                  .toLowerCase()
                  .slice(1)}
            </span>
          </dd>
        </dl>
      </div>
      <div>
        <div className="flex divide-x divide-gray-200">
          <div className="pl-4 pr-4 flex-1">
            <Link
              to={`${paths.LISTINGS}/${listing!.id}/property/details`}
              className="flex justify-center items-center py-3 text-sm text-gray-700 font-medium border border-transparent rounded-bl-lg hover:text-gray-500"
            >
              {/* Heroicon name: solid/users */}
              <svg
                className="w-5 h-5 text-gray-400"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                />
              </svg>
              <span className="ml-3">Edit</span>
            </Link>
          </div>
          <div className="px-2 flex-1">
            <button
              disabled={listing.status !== 'active'}
              className={`${
                listing.status !== 'active' && 'cursor-not-allowed'
              } py-3 text-sm text-gray-700 font-medium border border-transparent rounded-bl-lg hover:text-gray-500`}
              onClick={() =>
                window.open(`${config.sites.host}/${listing.sid}`, '_blank')
              }
            >
              <div className="flex">
                <EyeIcon className="w-5 h-5 text-gray-400" />
                <span className="ml-3">View</span>
              </div>
            </button>
          </div>
        </div>
      </div>
    </li>
  );
};

export default ListingCard;
